import { ADMIN_ORGANIZATION_FORM } from './index';
import { Action } from '../action';
import { OrganizationInfo } from '@shared/core';

export class AdminOrganizationFormInitAction implements Action {
	readonly type = ADMIN_ORGANIZATION_FORM.INIT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminOrganizationFormDestroyAction implements Action {
	readonly type = ADMIN_ORGANIZATION_FORM.DESTROY;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminOrganizationFormClickSubmitAction implements Action {
	readonly type = ADMIN_ORGANIZATION_FORM.CLICK_SUBMIT;
	constructor(
		public payload: OrganizationInfo,
		public correlationId?: number
	) {}
}

export class AdminOrganizationFormUpdateAction implements Action {
	readonly type = ADMIN_ORGANIZATION_FORM.UPDATE;
	constructor(
		public payload: OrganizationInfo,
		public correlationId?: number
	) {}
}

export class AdminOrganizationFormUpdateSuccessAction implements Action {
	readonly type = ADMIN_ORGANIZATION_FORM.UPDATE_SUCCESS;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminOrganizationFormUpdateFailureAction implements Action {
	readonly type = ADMIN_ORGANIZATION_FORM.UPDATE_FAILURE;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}

export class AdminOrganizationFormAddAction implements Action {
	readonly type = ADMIN_ORGANIZATION_FORM.ADD;
	constructor(
		public payload: OrganizationInfo,
		public correlationId?: number
	) {}
}

export class AdminOrganizationFormAddSuccessAction implements Action {
	readonly type = ADMIN_ORGANIZATION_FORM.ADD_SUCCESS;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminOrganizationFormAddFailureAction implements Action {
	readonly type = ADMIN_ORGANIZATION_FORM.ADD_FAILURE;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}

export class AdminOrganizationFormUploadAction implements Action {
	readonly type = ADMIN_ORGANIZATION_FORM.UPLOAD;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}

export class AdminOrganizationFormUploadSuccessAction implements Action {
	readonly type = ADMIN_ORGANIZATION_FORM.UPLOAD_SUCCESS;
	constructor(
		public payload: string,
		public correlationId?: number
	) {}
}

export class AdminOrganizationFormUploadFailureAction implements Action {
	readonly type = ADMIN_ORGANIZATION_FORM.UPLOAD_FAILURE;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}
